<template>
  <div class="create-event">
    <NavHeaderBar :showSearch="false" navBarTitle="Event Application" @backReturn="backReturn">
      <div class="right-header" v-if="eventId && !isDisable && (checkPer(['admin', 'app:event:del']) || checkPer(['admin', 'app:eventSd:del']))" @click="handleCancel">
        {{ $t('button.cancel') }}
      </div>
    </NavHeaderBar>

    <div v-if="!successStatus" class="event-invite-content">
      <div class="main-section" :key="componentKey">
        <div class="step-indicator">
          <div v-for="(stepItem, stepIndex) in stepList" :key="stepItem.value" class="step-content">
            <span class="step-item" :class="{'active': stepItem.value === activeTabs}">{{ stepItem.label }}</span>
            <span class="step-line" v-if="stepIndex !== stepList.length - 1"></span>
          </div>
        </div>

        <div class="message-info">
          <div class="section-title">{{ labelHeaderInfo[activeTabs].title }}</div>
          <div class="tip-txt" v-if="labelHeaderInfo[activeTabs].tips">
            <van-icon name="warning-o" color="#307bff" size="12" />{{ labelHeaderInfo[activeTabs].tips }}
          </div>
          <div class="mark-txt">{{ labelHeaderInfo[activeTabs].message }}</div>
        </div>

        <StepOne ref="stepOneRef" v-show="activeTabs === 0" :isDisable="isDisable" :singleDisable="singleDisable" @handleInfo="handleInfo" @changeType="changeType" :eventId="eventId" />
        <StepTwo ref="stepTwoRef" v-show="activeTabs === 1" :isDisable="isDisable" :customerId="customerId" :eventType="eventType" />
        <StepThree ref="stepThreeRef" v-show="activeTabs === 2" :isDisable="isDisable" :eventType="eventType" :eventId="eventId" />
        <StepFour ref="stepFourRef" v-show="activeTabs === 3" :isDisable="isDisable" :eventType="eventType" />
      </div>

      <div class="footer-btn">
        <van-button class="previous-btn" v-show="activeTabs !== 0" type="default" block @click="prevStep">{{ $t('button.previous') }}</van-button>
        <van-button v-if="activeTabs !== 3 || !isDisable" class="next-btn" type="info" block @click="nextStep">{{ activeTabs === 3 ? $t('button.submit') : $t('button.nextStep') }}</van-button>
      </div>
    </div>
    <div class="success-submit-status" v-else>
      <img class="success-img" src="@/assets/images/gouxuan.png" alt="">
      <!-- 当前门店mapping成功，接下来可通过visit收集更多门店信息 -->
      <span class="success-tip">{{ $t('tips.messageTwelve') }}.</span>
      <div class="visit-sell-in-btn" @click="toPage">{{ $t('button.eventExecution') }}</div>
    </div>
  </div>
</template>

<script>
import NavHeaderBar from '@/components/NavHeaderBar'
import { arsEventUpdateInfoApi, arsEventAddEventApi, arsEventInfoApi, arsEventUpdateEventApi, arsEventCancelApi, eventAddSdEventApi, eventUpdateSdEventApi } from '@/api/event'
import { eventUpdateSdInfoApi } from '@/api/salesDistribution'
import { mapState, mapMutations } from 'vuex'
import { Notify, Toast, Dialog } from 'vant'
import StepOne from './components/createEvent/StepOne'
import StepTwo from './components/createEvent/StepTwo'
export default {
  name: 'CreateEvent',
  components: {
    NavHeaderBar,
    StepOne: StepOne,
    StepTwo: StepTwo,
    StepThree: () => import('./components/createEvent/StepThree'),
    StepFour: () => import('./components/createEvent/StepFour')
  },
  data () {
    return {
      componentKey: 0,
      activeTabs: 0,
      stepList: [
        { label: '1', value: 0 },
        { label: '2', value: 1 },
        { label: '3', value: 2 },
        { label: '4', value: 3 }
      ],
      refList: ['stepOneRef', 'stepTwoRef', 'stepThreeRef', 'stepFourRef'],
      customerId: '',
      eventId: '',
      isDisable: false,
      singleDisable: false,
      eventType: 1, // event Type
      successStatus: false,
      currentData: {}
    }
  },
  watch: {
    // async customerId (newVal) {
    //   if (newVal) {
    //     const requestApi = this.eventType === 2 ? eventUpdateSdInfoApi : arsEventUpdateInfoApi
    //     const res = await requestApi(newVal, this.eventId)
    //     if (this.eventType === 2) {
    //       this.$refs.stepFourRef.editEcho(res.data)
    //     }
    //     this.$nextTick(() => {
    //       this.$refs.stepThreeRef.editEcho(res.data)
    //     })
    //   }
    // }
  },
  computed: {
    ...mapState(['selectedPolicy', 'myUserInfo']),
    ...mapState('event', ['eventInfo']),
    labelHeaderInfo () {
      return [{ title: this.$t('shared.titleEleven'), tips: '', message: '' },
        { title: this.$t('shared.titleTwelve', { type: `${this.eventType === 2 ? this.$t('shared.distributor') : this.$t('shared.store')}` }), tips: this.$t('shared.titleThirteen'), message: this.$t('shared.titleFourteen') },
        { title: this.$t('shared.titleFifteen'), tips: this.$t('shared.titleThirteen'), message: this.$t('shared.titleFourteen') },
        { title: this.$t('shared.titleSixteen'), tips: '', message: '' }]
    }
  },
  activated () {
    if (this.isNavigateToSdSelect) {
      const sdStoreSelect = JSON.parse(window.localStorage.getItem('sdStoreSelect'))
      if (sdStoreSelect) {
        this.$refs.stepTwoRef.customer.belongSd.id = sdStoreSelect.typeValue[0] ? sdStoreSelect.typeValue[0].id : ''
        this.$refs.stepTwoRef.customer.belongSd.sdName = sdStoreSelect.typeValue[0] ? sdStoreSelect.typeValue[0].sdName : ''
        window.localStorage.removeItem('sdStoreSelect')
      }
    } else {
      this.isDisable = false
      this.singleDisable = false
      const { eventId, customerId, customerName, pageType, eventType } = this.$route.query
      if (['salesDistribution'].includes(pageType)) {
        this.eventType = 2
      } else {
        this.eventType = Number(sessionStorage.getItem('eventType')) || Number(eventType) || 1
      }
      this.eventId = eventId || ''
      // this.customerId = customerId || ''
      if (this.eventId && this.activeTabs === 0) {
        this.getEventInfo()
      }
      if (customerId) {
        // if (['pendingEventStore', 'store', 'storeMaintain'].includes(pageType)) {
        //   this.singleDisable = true
        // }
        this.singleDisable = true
        this.$nextTick(() => {
          this.$refs.stepOneRef.onConfirmStore({ customerName, id: customerId })
        })
      }
    }
    this.isNavigateToSdSelect = false
  },
  deactivated () {
    this.successStatus = false
  },
  beforeRouteLeave (to, from, next) {
    if (to.path === '/shared/selectStoreSd') {
      this.isNavigateToSdSelect = true
    }
    next()
  },
  mounted () {},
  methods: {
    ...mapMutations(['setSelectedPolicy']),
    ...mapMutations('event', ['SET_EVENTINFO']),
    async nextStep () {
      const currentRef = this.$refs[this.refList[this.activeTabs]]
      if (!currentRef.checkVerify()) return
      if (this.activeTabs === 3) {
        const { eventType, startTime, endTime } = this.$refs.stepOneRef
        const { customer, decisionContact } = this.$refs.stepTwoRef.sendData()
        const { formThreeData, visitForm } = this.$refs.stepThreeRef
        const { formFourData, eventSd } = this.$refs.stepFourRef
        let data = {
          event: {
            id: this.eventId,
            eventType,
            startTime,
            endTime,
            customerId: this.customerId,
            policyId: this.selectedPolicy.id,
            ...formFourData
          }
        }
        if (this.eventType === 2) {
          data = {
            ...data,
            sd: {
              sd: customer,
              decisionContact
            },
            eventSd: eventSd,
            sdShelfList: visitForm.sdShelfList,
            projectSaleBeforeList: visitForm.projectSaleBeforeList,
            projectSalePredict: eventSd.projectSalePredict
          }
        } else {
          data = {
            ...data,
            customer: {
              customer,
              decisionContact
            },
            popup: {
              ...formThreeData
            },
            eventShelfList: visitForm.eventShelfList,
            projectSaleBeforeList: visitForm.projectSaleBeforeList
          }
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        let requestApi = ''
        if (this.eventType === 2) {
          requestApi = this.eventId ? eventUpdateSdEventApi : eventAddSdEventApi
        } else {
          requestApi = this.eventId ? arsEventUpdateEventApi : arsEventAddEventApi
        }
        requestApi(data).then(res => {
          Toast.clear()
          localStorage.removeItem('centerPoint')
          Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
          this.resetState()
          this.currentData = res.data
          this.successStatus = true
          // this.$router.go(-1)
        })
        return
      }
      this.activeTabs += 1
      if (this.activeTabs === 1) {
        this.$refs.stepTwoRef.getUpdateInfo(this.customerId)
        const requestApi = this.eventType === 2 ? eventUpdateSdInfoApi : arsEventUpdateInfoApi
        const res = await requestApi(this.customerId, this.eventId, { policyId: this.selectedPolicy.id })
        if (this.eventType === 2) {
          this.$refs.stepFourRef.editEcho(res.data)
        }
        this.$nextTick(() => {
          this.$refs.stepThreeRef.editEcho(res.data)
        })
      }
      if (sessionStorage.getItem('eventType')) {
        sessionStorage.removeItem('eventType')
      }
    },
    prevStep () {
      if (this.activeTabs === 0) return
      this.activeTabs -= 1
    },
    handleInfo (data = {}) {
      const { customerId } = data
      this.customerId = customerId
      // this.$nextTick(() => {
      //   this.$refs.stepTwoRef.getUpdateInfo(customerId)
      // })
    },
    backReturn () {
      sessionStorage.removeItem('eventType')
      this.resetState()
    },
    getEventInfo () {
      arsEventInfoApi(this.$route.query.eventId).then(res => {
        this.$nextTick(() => {
          res.data.customerName = res.data.targetName
          this.$refs.stepOneRef.editEcho(res.data)
          // this.$refs.stepFourRef.editEcho(res.data)
        })
        this.customerId = res.data.customerId
        res.data.policy.newPlanList = []
        res.data.policy.planList.forEach(planItem => {
          // 购买Product A/B 10 Pcs 送 B 2 Pcs
          const productName = planItem.productList.map(nameItem => nameItem.productName).join(' / ')
          const protoName = planItem.protoList.map(nameItem => nameItem.productName).join(' / ')
          res.data.policy.newPlanList.push(`${this.$t('shared.buy')} ${productName} ${planItem.buyCount} ${this.$t('form.pcs')} ${this.$t('shared.get')} ${protoName} ${planItem.giveCount} ${this.$t('form.pcs')}`)
        })
        this.setSelectedPolicy(res.data.policy)
        this.isDisable = res.data.isDisable
      })
    },
    resetState () {
      const initialData = this.$options.data.call(this)
      const newKey = (this.componentKey || 0) + 1
      Object.assign(this.$data, initialData)
      this.componentKey = newKey
      this.activeTabs = 0
      this.setSelectedPolicy(null)
    },
    handleCancel () {
      Dialog.confirm({
        message: this.$t('tips.messageThirteen'),
        confirmButtonText: this.$t('button.stillCancel'),
        cancelButtonText: this.$t('button.thinkAgain'),
        confirmButtonColor: '#d9001b'
      })
        .then(() => {
          Toast.loading({
            message: this.$t('shared.loading'),
            forbidClick: true,
            duration: 0
          })
          arsEventCancelApi(this.eventId).then(res => {
            Toast.clear()
            Notify({ type: 'success', message: this.$t('shared.success'), duration: 1500 })
            // sessionStorage.setItem('EVENT_LIST_NEED_REFRESH', 'true')
            this.$router.go(-1)
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    changeType (val) {
      this.eventType = val
      this.setSelectedPolicy(null)
    },
    toPage () {
      this.$router.replace(`/eventDetail?eventId=${this.currentData.id}&pageType=`)
      this.SET_EVENTINFO({ ...this.eventInfo, eventId: this.currentData.id })
    }
  }
}
</script>

<style lang="less" scoped>
.create-event {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f5fafe;
  .success-submit-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 100px;
    .success-img {
      width: 80px;
      height: 80px;
    }
    .success-tip {
      width: 260px;
      text-align: center;
      margin: 16px 0 40px 0;
      font-size: 13px;
    }
    .store-detail-btn,
    .visit-sell-in-btn {
      width: 260px;
      padding: 16px 0px;
      border: 1px solid #555;
      color: #555;
      text-align: center;
      font-weight: bold;
      font-size: 17px;
      border-radius: 30px;
      margin-bottom: 16px;
    }
    .visit-sell-in-btn {
      border-color: #307bff;
      color: #307bff;
    }
  }
  .right-header {
    font-size: 14px;
    color: red;
  }
  .message-info {
    padding: 20px 16px;
    padding-bottom: 0;
    margin-bottom: 10px;
    .section-title {
      font-size: 14px;
      font-weight: bold;
      color: #307bff;
    }
    .tip-txt {
      color: #307bff;
      font-size: 10px;
      margin-top: 10px;
      margin-bottom: 5px;
    }
    .mark-txt {
      font-size: 10px;
      color: #999;
    }
  }
  .event-invite-content {
    flex: 1;
    display: flex;
    overflow-y: auto;
    flex-direction: column;
  }
  .main-section {
    flex: 1;
    margin: 8px 0;
    overflow-y: auto;
    background-color: #fff;
  }
  .step-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    .step-content {
      display: flex;
      align-items: center;
    }
    .step-item {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      border: 1px solid #999;
      color: #999;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;

      &.active {
        border-color: #307bff;
        color: #307bff;
        background-color: #e6f1fc;
      }
    }

    .step-line {
      width: 30px;
      height: 1px;
      background-color: #999;
      margin: 0 8px;
    }
  }

  .footer-btn {
    display: flex;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    .previous-btn,
    .next-btn {
      border: none;
      font-weight: bold;
    }
    .previous-btn {
      color: #307bff;
    }
    .next-btn {
      background-color: #307bff;
    }
  }
}
</style>
